import React from "react";
import Title from "antd/es/typography/Title";
import Paragraph from "antd/es/typography/Paragraph";
import {
  UserOutlined,
  LockOutlined,
  EyeOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import stealthMark from "../../../../Assets/Images/logo.svg";
import StealthPreview, { Hidden } from "../../../../Components/StealthPreview";
import { hiringTeamFeatureCards } from "../../../../Utils/staticData";
import "./index.scss";

// A job as candidates see it with Stealth Mode on and off. Where a stealth
// job's company would be, the candidate app shows "Confidential", blurred.
// Same role and company as the live demo.
const jobPreview = {
  stealth: {
    avatar: <LockOutlined />,
    title: "SVP of Sales",
    subtitle: <Hidden label="Company name hidden">Confidential</Hidden>,
    location: "New York, NY",
    noteIcon: <LockOutlined />,
    note: "Company name hidden until a match",
  },
  visible: {
    avatar: "N",
    title: "SVP of Sales",
    subtitle: "Northwind Cloud",
    location: "New York, NY",
    noteIcon: <EyeOutlined />,
    note: "Company name visible to candidates",
  },
};

const BuiltForHiringTeams = () => {
  return (
    <div className="hiring-teams-wrapper" id="built-for-hiring-teams">
      <div className="hiring-teams-container">
        <div className="section-header">
          <Title level={2} className="section-heading">
            Built for Hiring Teams
          </Title>
          <Paragraph className="section-subtext">
            Quietly connect with top-tier candidates who match your requirements.
          </Paragraph>
        </div>

        <div className="hiring-teams-primary-card">
          <div className="hiring-diagram">
            <svg
              className="hiring-diagram-lines"
              viewBox="0 0 400 150"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <path d="M90 34 L200 116" stroke="#d8d7f7" strokeWidth="2" strokeDasharray="5 6" fill="none" />
              <path d="M310 34 L200 116" stroke="#d8d7f7" strokeWidth="2" strokeDasharray="5 6" fill="none" />
            </svg>
            <div className="hiring-diagram-node hiring-diagram-node--left">
              <UserOutlined /> VP of Sales
            </div>
            <div className="hiring-diagram-node hiring-diagram-node--right">
              <UserOutlined /> Staff Engineer
            </div>
            <div className="hiring-diagram-center">
              <img src={stealthMark} alt="Stealth Jobs" />
            </div>
          </div>
          <h3 className="hiring-teams-primary-title">Vetted, high-slope talent</h3>
          <p className="hiring-teams-primary-description">
            Access high-quality candidates instead of high-volume, low-fit
            applicants. We route the right candidates directly to your team.
          </p>
        </div>

        <div className="hiring-teams-cards-row">
          <div className="hiring-teams-card">
            <StealthPreview
              theme="dark"
              avatarShape="square"
              heading="Candidate view"
              className="hiring-stealth-preview"
              {...jobPreview}
            />
            <h4>{hiringTeamFeatureCards[0].title}</h4>
            <p>{hiringTeamFeatureCards[0].description}</p>
          </div>

          <div className="hiring-teams-card">
            {/* A short, opted-in shortlist rather than a search box: the
                copy is about receiving fewer, genuinely interested candidates. */}
            <div className="hiring-mockup hiring-mockup--light">
              <div className="hiring-shortlist-header">
                <span className="hiring-shortlist-title">Shortlist</span>
                <span className="hiring-shortlist-count">3 interested</span>
              </div>
              {[0, 1, 2].map((row) => (
                <div className="hiring-shortlist-row" key={row}>
                  <span className="hiring-shortlist-avatar">
                    <UserOutlined />
                  </span>
                  <span className="hiring-shortlist-lines" aria-hidden="true">
                    <span />
                    <span />
                  </span>
                  <span className="hiring-shortlist-badge">
                    <CheckCircleFilled /> Interested
                  </span>
                </div>
              ))}
            </div>
            <h4>{hiringTeamFeatureCards[1].title}</h4>
            <p>{hiringTeamFeatureCards[1].description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuiltForHiringTeams;
